import React from "react";

export function ColumnGrid({ children, withGaps, size, ...props }) {
    const { className, ...remainingProps } = props;
    return (
        <div className={'columns ' + (withGaps === true ? '' : 'col-gapless ') + (size === undefined ? '' : 'container no-margin no-padding grid-' + size + ' ') + (className ?? '')} {...remainingProps}>
            {children}
        </div>
    )
}

function assembleColumnInfo(width, widthXl, widthLg, widthMd, widthSm, widthXs) {
    width = width ?? 12;
    widthXl = widthXl ?? width;
    widthLg = widthLg ?? widthXl;
    widthMd = widthMd ?? widthLg;
    widthSm = widthSm ?? widthMd;
    widthXs = widthXs ?? widthSm;
    return `col-${width} col-xl-${widthXl} col-lg-${widthLg} col-md-${widthMd} col-sm-${widthSm} col-xs-${widthXs}`;
}

/**
 * A column of the grid column with the specified column sizes.
 * @param children
 * @param sizes Array of sizes from default -> xl -> lg -> md -> sm -> xs.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function Column({ children, sizes, ...props }) {
    const { className, ...remainingProps } = props;
    return (
        <div className={'column ' + assembleColumnInfo(...(sizes ?? [12])) + ' ' + (className ?? '')} {...remainingProps}>
            {children}
        </div>
    )
}

function calculateWidths(minWidth) {
    return assembleColumnInfo(...[1280,960,840,600,480,1].map(width => Math.min(12, Math.ceil(12 * minWidth / width))));
}

/**
 * A column of the column grid, that guarantees to be at least minWidth pixels wide.
 * @param children
 * @param minWidth Minimum width that should be guaranteed.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AutoColumn({ children, minWidth, ...props }) {
    const { className, ...remainingProps } = props;
    return (
        <div className={'column ' + calculateWidths(minWidth ?? 1280) + ' ' + (className ?? '')} {...remainingProps}>
            {children}
        </div>
    )
}
